var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 4.16654C3.33205 4.05573 3.35417 3.94602 3.39709 3.84386C3.44002 3.74169 3.50289 3.64912 3.58203 3.57154C4.49023 2.68124 5.70357 2.17049 6.97508 2.14324C8.24658 2.11599 9.48069 2.5743 10.4262 3.42488L10.7187 3.69821C11.3266 4.23079 12.1072 4.5244 12.9154 4.5244C13.7235 4.5244 14.5042 4.23079 15.112 3.69821L15.3195 3.50904C15.8279 3.10654 16.592 3.42821 16.6612 4.07238L16.6654 4.16654V11.6665C16.6653 11.7774 16.6432 11.8871 16.6003 11.9892C16.5574 12.0914 16.4945 12.184 16.4154 12.2615C15.5072 13.1518 14.2938 13.6626 13.0223 13.6898C11.7508 13.7171 10.5167 13.2588 9.5712 12.4082L9.2787 12.1349C8.68998 11.619 7.93851 11.3268 7.15596 11.3095C6.37342 11.2921 5.60973 11.5507 4.9987 12.0399V17.4999C4.99846 17.7123 4.91713 17.9166 4.77132 18.071C4.62552 18.2255 4.42624 18.3184 4.2142 18.3309C4.00217 18.3433 3.79338 18.2743 3.6305 18.138C3.46763 18.0017 3.36295 17.8083 3.33786 17.5974L3.33203 17.4999V4.16654Z",
    fill: "#B0AFB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFilled);
export default __webpack_public_path__ + "static/media/flag-filled.26a39882a21a84f91dbf0938cc6636df.svg";
export { ForwardRef as ReactComponent };